var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './addedCaller.module.scss';
const callStateMessage = {
    ringing: 'Ringing...',
    failed: 'Call failed',
    busy: 'Call busy',
    noAnswer: 'No answer',
    inProgress: '',
};
export class AddedCaller extends PureComponent {
    render() {
        const _a = this.props, { className, isOnHold, onHoldToggle, onEndCall, caller, callState } = _a, otherProps = __rest(_a, ["className", "isOnHold", "onHoldToggle", "onEndCall", "caller", "callState"]);
        const rootClass = classnames({
            [styles.addedCaller]: true,
        }, className);
        const canRemove = onEndCall && ['ringing', 'inProgress'].includes(callState);
        const canHold = onHoldToggle && callState === 'inProgress';
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx(Icon, { className: styles.icon, name: "plus", size: 24 }), _jsx("div", Object.assign({ className: styles.avatarWrap }, { children: _jsx(Avatar, { user: caller }) })), _jsx("span", Object.assign({ className: styles.name }, { children: caller.display_name || caller.name || caller.phone_number })), _jsx("span", Object.assign({ className: styles.callState }, { children: callStateMessage[callState] })), _jsxs("div", Object.assign({ className: styles.buttons }, { children: [canRemove && (_jsx(Button, Object.assign({ className: styles.button, onClick: onEndCall, variant: "danger" }, { children: "End call" }))), canHold && (_jsx(Button, Object.assign({ variant: isOnHold ? 'primary' : 'secondary', className: styles.button, onClick: onHoldToggle }, { children: isOnHold ? 'Unhold' : 'Hold' })))] }))] })));
    }
}
